import { useCallback } from 'react';
import { clearMultiSelection } from '@components/MainStage/clearMultiSelection';
import { getFocusedNodeIds } from '@components/MainStage/focusOn.helpers';
import { getFocusOnState } from '@components/MainStage/focusOn.store';
import { canvasState } from '@components/MainStage/store';
import { useProject } from '@context/Project';
import { useProjectFilters } from '@context/ProjectFilters/ProjectFiltersProvider';
import { useProjectDashboardActions } from '@store/zustand/project-dashboard-filters/project-dashboard-filters.store';

const useFocusOn = () => {
  const { handleClearAllFilters } = useProjectFilters();
  const { clearDashboardFilters } = useProjectDashboardActions();
  const { drawer, handleCloseDrawer } = useProject();

  const enterFocus = useCallback(
    async (sourceId: string, sourceName: string) => {
      if (drawer) {
        try {
          await handleCloseDrawer();
        } catch {
          return false;
        }
      }

      const focusedIds = getFocusedNodeIds(canvasState().nodes, sourceId);

      handleClearAllFilters();
      clearDashboardFilters();

      getFocusOnState().setFocus({ sourceId, sourceName, focusedIds });

      return true;
    },
    [drawer, handleCloseDrawer, handleClearAllFilters, clearDashboardFilters],
  );

  const exitFocus = useCallback(() => {
    getFocusOnState().clear();
    clearMultiSelection();
  }, []);

  return { enterFocus, exitFocus };
};

export default useFocusOn;
